import classNames from "classnames";
import { observer } from "mobx-react-lite";
import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { translationHookOptions } from "../../app/localization/localization";

interface IParams {
  title: string;
  link?: string;
  className?: string;
}

const TreeElement: React.FC<IParams> = ({ title, link, className }) => {
  const [t] = useTranslation(["translation"], translationHookOptions);
  const formatTitleDiv = (title: string) => {
    return (
      <div className={classNames(`node-title ${className}`, title ? "" : "font-italic")}>
        {title ? title : t("empty_title_node")}
      </div>
    );
  };

  return (
    <>
      {link ? (
        <div className="odgElement">
          <Link to={link}>{formatTitleDiv(title)}</Link>
        </div>
      ) : (
        <div className="odgElement">{formatTitleDiv(title)}</div>
      )}
    </>
  );
};

export default observer(TreeElement);
